module.exports = __webpack_public_path__ + "static/BullfrogMove-9508b089cd798a506d469e4f79943f97.gif";